export default "__VITE_ASSET__CjLPm0vQ__"